import { ApolloError } from "@apollo/client";

/** Code the API attaches when a payment association lives outside the payment's partner family. */
export const PAYMENT_ASSOCIATION_TENANT_MISMATCH_CODE = "PAYMENT_ASSOCIATION_TENANT_MISMATCH";

export type CrossTenantMismatch = {
  /** "Facility", "Report", or "Submission". */
  targetKind: string;
  targetId: string;
  /** Organization that owns the target and will be billed its fees. */
  targetTenantName: string;
  /** Organization the payment is being recorded under. */
  paymentTenantName: string;
};

function readString(value: unknown): string | undefined {
  return typeof value === "string" && value.length > 0 ? value : undefined;
}

/**
 * The cross-organization details from a payment save that failed the
 * tenant-mismatch guard, or undefined when the error is anything else.
 */
export function getCrossTenantMismatch(error: unknown): CrossTenantMismatch | undefined {
  if (!(error instanceof ApolloError)) {
    return undefined;
  }
  for (const gqlError of error.graphQLErrors ?? []) {
    const extensions = gqlError.extensions;
    if (extensions?.code !== PAYMENT_ASSOCIATION_TENANT_MISMATCH_CODE) {
      continue;
    }
    return {
      targetKind: readString(extensions.targetKind) ?? "Association",
      targetId: readString(extensions.targetId) ?? "",
      targetTenantName: readString(extensions.targetTenantName) ?? "another organization",
      paymentTenantName: readString(extensions.paymentTenantName) ?? "this organization",
    };
  }
  return undefined;
}
